import ClientExportModal from './ClientExportModal.view';

export default ClientExportModal;
